import { render, staticRenderFns } from "./NotificationsModal.vue?vue&type=template&id=a4cb53f4&scoped=true&"
import script from "./NotificationsModal.vue?vue&type=script&lang=js&"
export * from "./NotificationsModal.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsModal.vue?vue&type=style&index=0&id=a4cb53f4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4cb53f4",
  null
  
)

export default component.exports